import $ from 'jquery';

export default function printDetails () {
    if(window.matchMedia('print').matches) {
	    [...document.querySelectorAll("details")].forEach(detailEl => {
	        detailEl.setAttribute("open", true);
	    });
	}
}
